import { render } from "./professorEditar.vue?vue&type=template&id=1c5fb48d"
import script from "./professorEditar.vue?vue&type=script&lang=js"
export * from "./professorEditar.vue?vue&type=script&lang=js"

import "./professorEditar.vue?vue&type=style&index=0&id=1c5fb48d&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__